import { render } from "./DashboardLeftCurrentGoals.vue?vue&type=template&id=5288e3c2&scoped=true"
import script from "./DashboardLeftCurrentGoals.vue?vue&type=script&lang=js"
export * from "./DashboardLeftCurrentGoals.vue?vue&type=script&lang=js"

import "./DashboardLeftCurrentGoals.vue?vue&type=style&index=0&id=5288e3c2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5288e3c2"

export default script